import ComputerCoursePage from "./computerCoursePage"

export default ComputerCoursePage;